// Dynamic Viscosity units with conversion factors to pascal second (Pa·s)
export const viscosityUnits = [
  { id: 'pascal-second', name: 'Pascal Second', symbol: 'Pa·s', plural: 'Pascal Seconds', factor: 1 },
  { id: 'kilogram-per-meter-second', name: 'Kilogram/Meter·Second', symbol: 'kg/(m·s)', plural: 'Kilograms/Meter·Second', factor: 1 },
  { id: 'millipascal-second', name: 'Millipascal Second', symbol: 'mPa·s', plural: 'Millipascal Seconds', factor: 0.001 },
  { id: 'centipoise', name: 'Centipoise', symbol: 'cP', plural: 'Centipoise', factor: 0.001 },
  { id: 'poise', name: 'Poise', symbol: 'P', plural: 'Poise', factor: 0.1 },
  { id: 'micropoise', name: 'Micropoise', symbol: 'µP', plural: 'Micropoise', factor: 0.0000001 },
  { id: 'pound-per-foot-second', name: 'Pound/Foot·Second', symbol: 'lb/(ft·s)', plural: 'Pounds/Foot·Second', factor: 1.488164 },
  { id: 'pound-per-foot-hour', name: 'Pound/Foot·Hour', symbol: 'lb/(ft·h)', plural: 'Pounds/Foot·Hour', factor: 0.000413379 },
  { id: 'pound-force-second-per-sqft', name: 'Pound-force Second/ft²', symbol: 'lbf·s/ft²', plural: 'Pound-force Seconds/ft²', factor: 47.88026 },
  { id: 'pound-force-second-per-sqin', name: 'Pound-force Second/in²', symbol: 'lbf·s/in²', plural: 'Pound-force Seconds/in²', factor: 6894.757 },
  { id: 'slug-per-foot-second', name: 'Slug/Foot·Second', symbol: 'slug/(ft·s)', plural: 'Slugs/Foot·Second', factor: 47.88026 },
];

export const popularViscosityConversions = [
  { from: 'pascal-second', to: 'centipoise' },
  { from: 'centipoise', to: 'pascal-second' },
  { from: 'poise', to: 'centipoise' },
  { from: 'centipoise', to: 'poise' },
  { from: 'pascal-second', to: 'poise' },
  { from: 'millipascal-second', to: 'centipoise' },
  { from: 'pound-per-foot-second', to: 'pascal-second' },
];

export const getUnitById = (id) => viscosityUnits.find(unit => unit.id === id);

export const convertViscosity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert dynamic viscosity units and learn the conversion formula.`;
};
